import React, { useState, useEffect } from 'react';
import api from '../api/client';

const btnPrimary = { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer' };
const btnGhost = { padding: '7px 12px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnDanger = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

const TYPE_COLORS = {
  socks5: '#534AB7',
  socks4: '#2980b9',
  http: '#27ae60',
  https: '#27ae60',
  mtproto: '#e67e22',
};

const TYPE_LABELS = {
  socks5: 'SOCKS5',
  socks4: 'SOCKS4',
  http: 'HTTP',
  https: 'HTTPS',
  mtproto: 'MTProto',
};

const FORMATS = [
  { label: 'SOCKS5 (user:pass@host:port)', placeholder: 'socks5://user:pass@1.2.3.4:1080' },
  { label: 'SOCKS5 (host:port:user:pass)', placeholder: 'socks5://1.2.3.4:1080:user:pass' },
  { label: 'SOCKS4', placeholder: 'socks4://1.2.3.4:1080' },
  { label: 'HTTP/HTTPS', placeholder: 'http://user:pass@1.2.3.4:8080' },
  { label: 'MTProto (Telegram Desktop)', placeholder: 'mtproto://149.154.167.50:443:secret_hex' },
  { label: 'Telegram deeplink', placeholder: 'tg://proxy?server=1.2.3.4&port=443&secret=abc...' },
  { label: 'Без схемы (→ SOCKS5)', placeholder: '1.2.3.4:1080:user:pass' },
];

export default function Proxies() {
  const [proxies, setProxies] = useState([]);
  const [text, setText] = useState('');
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const [showFormats, setShowFormats] = useState(false);

  const load = async () => { const { data } = await api.get('/proxies'); setProxies(data); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!text.trim()) return;
    setLoading(true);
    try { await api.post('/proxies', { text }); setText(''); await load(); }
    catch (e) { alert(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const del = async (id) => { await api.delete(`/proxies/${id}`); await load(); };

  const delBulk = async () => {
    if (!selected.length) return;
    if (!window.confirm(`Удалить ${selected.length} прокси?`)) return;
    await api.post('/proxies/delete-bulk', selected);
    setSelected([]); await load();
  };

  const check = async (id) => {
    setChecking(true);
    await api.post(`/proxies/${id}/check`);
    await load(); setChecking(false);
  };

  const checkAll = async () => {
    setChecking(true);
    await api.post('/proxies/check-all');
    await load(); setChecking(false);
  };

  const detectAllGeo = async () => {
    setChecking(true);
    await api.post('/proxies/detect-all-geo');
    await load(); setChecking(false);
  };

  const toggleSelect = (id) => setSelected(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id]);
  const selectAll = () => setSelected(proxies.map(p => p.id));
  const clearSelect = () => setSelected([]);

  const statusIcon = (p) => {
    if (p.is_working === null || p.is_working === undefined) return <span style={{ color: '#aaa' }}>○ не проверен</span>;
    return p.is_working
      ? <span style={{ color: '#27ae60' }}>● работает</span>
      : <span style={{ color: '#c0392b' }}>● не работает</span>;
  };

  const working = proxies.filter(p => p.is_working === true).length;
  const broken = proxies.filter(p => p.is_working === false).length;
  const unchecked = proxies.filter(p => p.is_working === null || p.is_working === undefined).length;

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Прокси</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          {selected.length > 0 && <button onClick={delBulk} style={btnDanger}>🗑 Удалить ({selected.length})</button>}
          <button onClick={checkAll} disabled={checking} style={btnGhost}>{checking ? 'Проверяем...' : '🔍 Проверить все'}</button>
        </div>
      </div>

      {/* Статистика */}
      {proxies.length > 0 && (
        <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
          {[
            { label: 'Всего', value: proxies.length, color: '#555' },
            { label: 'Работают', value: working, color: '#27ae60' },
            { label: 'Не работают', value: broken, color: '#c0392b' },
            { label: 'Не проверены', value: unchecked, color: '#aaa' },
          ].map(s => (
            <div key={s.label} style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 8, padding: '10px 16px', fontSize: 13, color: s.color }}>
              {s.label}: <b>{s.value}</b>
            </div>
          ))}
        </div>
      )}

      {/* Добавление */}
      <div style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 10, padding: 16, marginBottom: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 500 }}>Добавить прокси</div>
          <button onClick={() => setShowFormats(!showFormats)} style={{ ...btnGhost, fontSize: 12, padding: '4px 10px' }}>
            {showFormats ? 'Скрыть форматы' : 'Поддерживаемые форматы'}
          </button>
        </div>

        {showFormats && (
          <div style={{ background: '#f8f8f7', borderRadius: 8, padding: 12, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 8, color: '#555' }}>Поддерживаемые форматы прокси:</div>
            {FORMATS.map((f, i) => (
              <div key={i} style={{ marginBottom: 6 }}>
                <span style={{ fontSize: 11, color: '#888', display: 'block' }}>{f.label}</span>
                <code style={{ fontSize: 12, color: '#534AB7', cursor: 'pointer' }}
                  onClick={() => setText(t => t ? t + '\n' + f.placeholder : f.placeholder)}>
                  {f.placeholder}
                </code>
              </div>
            ))}
            <div style={{ fontSize: 11, color: '#aaa', marginTop: 8 }}>Нажми на пример чтобы добавить в поле</div>
          </div>
        )}

        <div style={{ fontSize: 12, color: '#aaa', marginBottom: 8 }}>
          Каждый прокси с новой строки. Поддерживаются: SOCKS5, SOCKS4, HTTP, HTTPS, MTProto, Telegram deeplinks
        </div>
        <textarea
          value={text} onChange={e => setText(e.target.value)}
          placeholder={"socks5://user:pass@1.2.3.4:1080\nhttp://user:pass@5.6.7.8:8080\nmtproto://149.154.167.50:443:secret\ntg://proxy?server=1.2.3.4&port=443&secret=abc"}
          rows={5}
          style={{ width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, fontFamily: 'monospace', resize: 'vertical', boxSizing: 'border-box', outline: 'none', marginBottom: 10 }}
        />
        <button onClick={add} disabled={loading} style={btnPrimary}>{loading ? 'Добавляем...' : '+ Добавить'}</button>
      </div>

      {/* Список */}
      {proxies.length === 0 && (
        <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 14 }}>Прокси не добавлены</div>
      )}

      {proxies.length > 0 && (
        <div style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
          <button onClick={selectAll} style={btnGhost}>Выбрать все</button>
          {selected.length > 0 && <button onClick={clearSelect} style={btnGhost}>Снять выбор</button>}
        </div>
      )}

      <div style={{ display: 'grid', gap: 8 }}>
        {proxies.map(p => (
          <div key={p.id} style={{ background: '#fff', border: `1px solid ${selected.includes(p.id) ? '#534AB7' : '#e8e8e6'}`, borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
            <input type="checkbox" checked={selected.includes(p.id)} onChange={() => toggleSelect(p.id)} />
            <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 7px', borderRadius: 5, background: TYPE_COLORS[p.proxy_type] + '18', color: TYPE_COLORS[p.proxy_type] }}>
              {TYPE_LABELS[p.proxy_type] || p.proxy_type?.toUpperCase()}
            </span>
            {p.flag && p.flag !== '🌐' && (
              <span style={{ fontSize: 18, flexShrink: 0 }} title={p.country_name}>{p.flag}</span>
            )}
            <div style={{ flex: 1, fontFamily: 'monospace', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.url}</div>
            <div style={{ fontSize: 12, flexShrink: 0 }}>{statusIcon(p)}</div>
            {p.checked_at && <div style={{ fontSize: 11, color: '#aaa', flexShrink: 0 }}>{new Date(p.checked_at).toLocaleString('ru')}</div>}
            <button onClick={() => check(p.id)} disabled={checking} style={btnGhost}>🔍</button>
            <button onClick={() => del(p.id)} style={btnDanger}>🗑</button>
          </div>
        ))}
      </div>
    </div>
  );
}
